// JavaScript Document


function initStadortSelectContent() {

   

    const standortSelectContent    = document.querySelector('.standort-select-content');

    const standortSelectHolders    = document.querySelectorAll('.standort-select-content-holder');

    const standorteItems    = standortSelectContent.querySelectorAll('.dropdown-item');
    const btn               = standortSelectContent.querySelector('.btn');
    let   btnTitle          = btn.dataset.title;


   let i = 0;
    standorteItems.forEach(function(standorteItem){

        if (i == 0) {
            setVal(standorteItem.dataset.termId);
        }

        standorteItem.addEventListener('click', function(){

            const termId    = this.dataset.termId;

            setVal(termId);

            if (termId === 'all') {
                resetDropdown();
                return false;
            }

            
            // if form input standort exist, set the value


        });
        i++;


    });

    function setVal(termId) {

        
        const item = standortSelectContent.querySelector('[data-term-id="'+termId+'"]');

        btn.innerHTML   = item.innerHTML;
        const title     = item.getAttribute("title");

        standorteItems.forEach(function(standorteItem){ 
            standorteItem.classList.remove("active");
        })
        item.classList.add("active");

        standortSelectHolders.forEach(standortSelectHolder => {
            standortSelectHolder.style.display = 'none';

        });

        document.querySelector('#'+termId).style.display = 'block';

       

    }

    function resetDropdown() {

        const listItems = document.querySelectorAll('#'+targetListId+' .stellen-item');


        btnTitle = btn.dataset.title;
        btn.innerHTML = btnTitle;
        standorteItems.forEach(function(standorteItem){ 
            standorteItem.classList.remove("active");
        });
        
        listItems.forEach(function(listItem){
            listItem.classList.remove('d-none');
        });



    }

  


}
